import Vue from 'vue'
import Vuex from 'vuex'
import plan from './plan'
import district from './district'
import user from './user'
import theme from './theme'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    plan,
    district,
    user,
    theme
  }
})
